var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},_vm._l((_vm.formattedRuleList),function(rule){return _c('rule-list',{key:rule.id,attrs:{"rule-list-data":rule,"selectedId":_vm.selectedId},on:{"remove-rule":_vm.removeRuleLayout,"update:selectedId":_vm.setSelectedId}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }